__turbopack_context__.v({
  "app_light_theme": "message-empty-window-module-scss-module__GCMD0G__app_light_theme",
  "messageEmptyWindow": "message-empty-window-module-scss-module__GCMD0G__messageEmptyWindow",
  "messageEmptyWindow__botImage": "message-empty-window-module-scss-module__GCMD0G__messageEmptyWindow__botImage",
  "messageEmptyWindow__inner": "message-empty-window-module-scss-module__GCMD0G__messageEmptyWindow__inner",
  "messageEmptyWindow__questionWrap": "message-empty-window-module-scss-module__GCMD0G__messageEmptyWindow__questionWrap",
  "messageEmptyWindow__textBlock": "message-empty-window-module-scss-module__GCMD0G__messageEmptyWindow__textBlock",
  "note": "message-empty-window-module-scss-module__GCMD0G__note",
  "smooth-float": "message-empty-window-module-scss-module__GCMD0G__smooth-float",
});
